import React, { useEffect, useState } from 'react';
import axios from "axios";
import Layout from '../../layouts/PayrollLayout';
import { getToken } from "../../utils/tokenUtils";
import { useHolidayMaster } from "../../contexts/HolidayContext";

export default function AttendanceLeave() {
  const { holidays, fetchHolidays, pagination } = useHolidayMaster();
  
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = getToken()

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      const dummyAttendance = [
        { id: 1, name: 'John Doe', present: 22, leave: 2, lop: 1 },
        { id: 2, name: 'Jane Smith', present: 20, leave: 4, lop: 2 },
        { id: 3, name: 'Michael Johnson', present: 23, leave: 1, lop: 0 },
        { id: 4, name: 'Emily Davis', present: 19, leave: 5, lop: 3 },
      ];
      setRecords(dummyAttendance);
      fetchHolidays();
      setLoading(false);
    }, 1000);
  }, [token]);

  const handleImport = (e) => {
    const file = e.target.files[0];
  };

  return (
    <Layout title="Attendance & Leave">
      <div className="flex flex-col gap-y-2">

        {/* Top Buttons */}
        <div className="bg-white dark:bg-gray-900 p-4 mx-2 rounded-2xl shadow overflow-x-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <h2 className="md:text-xl text-lg font-semibold dark:text-white">Attendance Management</h2>
          <label className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg cursor-pointer">
            Import Attendance
            <input type="file" accept=".csv" onChange={handleImport} className="hidden" />
          </label>
        </div>

        {/* Attendance Table */}
        <div className="bg-white mx-2 dark:bg-gray-900 p-4 rounded-2xl shadow overflow-x-auto">
          <h3 className="text-lg font-medium mb-4 dark:text-white">Attendance Records</h3>
          <div className='overflow-x-auto bg-white shadow-md rounded-lg'> 
            <table className="min-w-full table-auto md:table-fixed text-sm">
              <thead className="bg-gray-100 dark:bg-gray-950">
                <tr>
                  <th className="py-2 px-4 dark:text-white text-left text-xs md:text-sm text-gray-700 whitespace-nowrap">Employee</th>
                  <th className="py-2 px-4 dark:text-white text-left text-xs md:text-sm text-gray-700 whitespace-nowrap">Days Present</th>
                  <th className="py-2 px-4 dark:text-white text-left text-xs md:text-sm text-gray-700 whitespace-nowrap">Leaves Taken</th>
                  <th className="py-2 px-4 dark:text-white text-left text-xs md:text-sm text-gray-700 whitespace-nowrap">LOP</th>
                  <th className="py-2 px-4 dark:text-white text-left text-xs md:text-sm text-gray-700 whitespace-nowrap">Actions</th>
                </tr>
              </thead>
              <tbody>
              {loading ? (
                <tr className="border-b hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700">
                  <td colSpan="6" className="py-2 px-4 text-xs md:text-sm whitespace-nowrap">
                    <div className="animate-spin h-6 w-6 border-2 border-blue-500 border-t-transparent rounded-full mx-auto mb-2 mt-2"></div>
                    {/* <p className="text-sm text-center text-gray-500">Loading reports...</p> */}
                  </td>
                </tr>
              ) : records.length === 0 ? (
                <tr className="border-b hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700">
                  <td colSpan="6" className="py-2 px-4 text-xs md:text-sm whitespace-nowrap">No reports found</td>
                </tr>
              ) : (
                records.map(r => (
                  <tr key={r.id} className="border-b hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700">
                    <td className="py-2 px-4 dark:text-white text-xs md:text-sm whitespace-nowrap">{r.name}</td>
                    <td className="py-2 px-4 dark:text-white text-xs md:text-sm whitespace-nowrap">{r.present}</td>
                    <td className="py-2 px-4 dark:text-white text-xs md:text-sm whitespace-nowrap">{r.leave}</td>
                    <td className="py-2 px-4 dark:text-white text-xs md:text-sm whitespace-nowrap">{r.lop}</td>
                    <td className="py-2 px-4 dark:text-white text-xs md:text-sm whitespace-nowrap">
                      <button className="text-blue-600 dark:text-cyan-600 underline underline-offset-4">Mark Leave</button>
                    </td>
                  </tr>
                ))
              )}
              </tbody>
            </table>
          </div> 
        </div>

        {/* Holiday Calendar */}
        <div className="bg-white mx-2 dark:bg-gray-900 p-4 rounded-2xl shadow">
          <h3 className="text-lg font-medium mb-4 dark:text-white">Holiday Calendar</h3>
          <ul className="list-disc ml-6 space-y-2">
            {holidays.map((h, index) => (
              <li key={index} className="text-sm dark:text-white">
                {h.date} - {h.occasion}
              </li>
            ))}
          </ul>
        </div>

      </div>
    </Layout>
  );
}
